'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Raven from 'raven-js';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
class ThreadWithDeletedMessagesBanner extends Component {
  constructor(props) {
    super(props);
    this.onClickViewMessages = this.onClickViewMessages.bind(this);
    this.onClickDeleteMessages = this.onClickDeleteMessages.bind(this);
  }
  componentDidMount() {
    Raven.capturePageEvent('viewThreadWithDeletedMessagesBanner');
  }
  onClickViewMessages() {
    const {
      threadId,
      onClickViewMessages
    } = this.props;
    onClickViewMessages({
      threadId,
      includeDeletedHistory: true
    });
  }
  onClickDeleteMessages() {
    const {
      threadId,
      onClickDeleteMessages
    } = this.props;
    onClickDeleteMessages({
      threadId
    });
  }
  renderViewMessagesLink() {
    return /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: this.onClickViewMessages,
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.threadContainsDeletedMessages.viewMessagesLink"
      })
    });
  }
  renderHardDeleteLink() {
    return /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: this.onClickDeleteMessages,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.threadContainsDeletedMessages.deleteForeverLink"
      })
    });
  }
  render() {
    const {
      numSoftDeletedMessages,
      shouldShowDeletedMessagesBanner
    } = this.props;
    return shouldShowDeletedMessagesBanner ? /*#__PURE__*/_jsx(View, {
      margin: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(Alert, {
        minBlockSize: "40px",
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-thread-view.thread-deletion.threadContainsDeletedMessages.title",
            options: {
              count: numSoftDeletedMessages,
              viewLink: this.renderViewMessagesLink(),
              deleteForeverLink: this.renderHardDeleteLink()
            }
          })
        })
      })
    }) : null;
  }
}
ThreadWithDeletedMessagesBanner.displayName = 'ThreadWithDeletedMessagesBanner';
ThreadWithDeletedMessagesBanner.propTypes = {
  numSoftDeletedMessages: PropTypes.number.isRequired,
  onClickDeleteMessages: PropTypes.func.isRequired,
  onClickViewMessages: PropTypes.func.isRequired,
  shouldShowDeletedMessagesBanner: PropTypes.bool.isRequired,
  threadId: PropTypes.string.isRequired
};
export default ThreadWithDeletedMessagesBanner;